/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import type { OrganizationTheme } from "../../types";

export const warmEarthyTheme: OrganizationTheme = {
  id: "warm-earthy",
  name: "Warm Earthy",
  description: "Rich, warm palette with golden yellows and deep browns",
  recommendedFor: [
    "Woodworking",
    "Custom Homes",
    "Restoration",
    "Interior Design",
  ],

  colors: {
    primary: {
      name: "Deep Walnut",
      hex: "#573D1C",
      hsl: "30 52% 22%",
      rgb: [87, 61, 28],
    },
    primaryForeground: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    secondary: {
      name: "Sunlit Clay",
      hex: "#D9AE61",
      hsl: "39 62% 61%",
      rgb: [217, 174, 97],
    },
    secondaryForeground: {
      name: "Deep Walnut",
      hex: "#573D1C",
      hsl: "30 52% 22%",
      rgb: [87, 61, 28],
    },
    muted: {
      name: "Light Gray",
      hex: "#F5F5F5",
      hsl: "0 0% 96%",
      rgb: [245, 245, 245],
    },
    mutedForeground: {
      name: "Medium Gray",
      hex: "#666666",
      hsl: "0 0% 40%",
      rgb: [102, 102, 102],
    },
    card: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    cardForeground: {
      name: "Near Black",
      hex: "#1F1F1F",
      hsl: "0 0% 12%",
      rgb: [31, 31, 31],
    },
    background: {
      name: "White",
      hex: "#FFFFFF",
      hsl: "0 0% 100%",
      rgb: [255, 255, 255],
    },
    foreground: {
      name: "Near Black",
      hex: "#1F1F1F",
      hsl: "0 0% 12%",
      rgb: [31, 31, 31],
    },
  },

  cssVariables: {
    "--primary": "30 52% 22%",
    "--primary-foreground": "0 0% 100%",
    "--secondary": "39 62% 61%",
    "--secondary-foreground": "30 52% 22%",
    "--muted": "0 0% 96%",
    "--muted-foreground": "0 0% 40%",
    "--card": "0 0% 100%",
    "--card-foreground": "0 0% 12%",
    "--background": "0 0% 100%",
    "--foreground": "0 0% 12%",
    // Semantic colors — warm-toned, grounded alongside walnut/clay
    "--success": "145 55% 38%",
    "--success-foreground": "0 0% 98%",
    "--warning": "35 78% 48%",
    "--warning-foreground": "0 0% 12%",
    "--error": "2 68% 45%",
    "--error-foreground": "0 0% 98%",
    "--info": "215 55% 48%",
    "--info-foreground": "0 0% 98%",
    "--destructive": "2 68% 45%",
    "--destructive-foreground": "0 0% 98%",
    // Sidebar / warm surface — subtle tint of secondary hue
    "--background-warm": "39 20% 98%",
    "--background-warm-alt": "39 15% 96%",
    // Extended palette — warm-toned accents complementing walnut/clay
    "--palette-violet": "262 45% 50%",
    "--palette-teal": "175 50% 36%",
    "--palette-pink": "342 55% 48%",
    "--palette-orange": "16 80% 48%",
    "--palette-sky": "202 55% 42%",
  },
};
